import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { EDIT_ANNOUNCEMENT_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { RecipientSelection } from './useGetAnnouncementDetails';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface EditAnnouncementRequest {
  title?: string;
  description?: string;
  priority?: boolean;
  startDate?: string;
  endDate?: string;
  announcementType: string;
  fileUuids: string[];
  recipientSelection?: RecipientSelection;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutEditAnnouncement = ({ onSuccess, onError, uuid }: Input) => {
  const putEditAnnouncement = async (requestData: EditAnnouncementRequest) => {
    const res = await axiosClient.put<void>(EDIT_ANNOUNCEMENT_URL(uuid), requestData);
    return res.data;
  };

  return useCustomMutation(putEditAnnouncement, {
    onSuccess,
    onError,
  });
};
